// Câu báo lỗi cho người dùng: tiếng Việt, không lộ chi tiết kỹ thuật (chi tiết ghi ra console để hỗ trợ tra cứu).
const VI = /[àáảãạăằắẳẵặâầấẩẫậđèéẻẽẹêềếểễệìíỉĩịòóỏõọôồốổỗộơờớởỡợùúủũụưừứửữựỳýỷỹỵ]/i;

export function friendly(e: unknown, fallback = "Có lỗi xảy ra. Vui lòng thử lại."): string {
  const err = (e ?? {}) as { code?: string; message?: string };
  console.error("[AHG Hub]", e);
  if (typeof navigator !== "undefined" && !navigator.onLine) return "Mất kết nối mạng. Kiểm tra Wi-Fi hoặc 4G rồi thử lại.";
  const code = String(err.code ?? "");
  const msg = String(err.message ?? "");
  // Lỗi nghiệp vụ do máy chủ Hub trả về đã là tiếng Việt → bỏ phần mã kỹ thuật nếu có
  if (VI.test(msg) && !/firebase|console\.|https?:\/\//i.test(msg)) return msg.replace(/\s*\(?\[?\d{3}\]?\)?\s*$/, "").trim();
  if (/internal|unknown|unavailable|network|deadline/.test(code) || /network|fetch|Failed to fetch/i.test(msg))
    return "Mất kết nối hoặc máy chủ đang bận. Vui lòng thử lại sau ít phút.";
  if (/permission-denied/.test(code)) return "Bạn không có quyền với nội dung này.";
  if (/failed-precondition/.test(code)) return "Hệ thống đang cập nhật dữ liệu. Vui lòng thử lại sau ít phút.";
  if (/unauthenticated/.test(code)) return "Phiên đăng nhập đã hết. Vui lòng đăng nhập lại.";
  if (/not-found/.test(code)) return "Không tìm thấy nội dung này (có thể đã bị xóa).";
  return fallback;
}

/** Thông báo nổi góc màn hình, tự tắt (thay cho hộp thoại của trình duyệt). */
export function toast(message: string, kind: "err" | "ok" = "err") {
  let box = document.getElementById("toasts");
  if (!box) { box = document.createElement("div"); box.id = "toasts"; box.setAttribute("role", "status"); document.body.appendChild(box); }
  const el = document.createElement("div");
  el.className = `toast ${kind}`;
  el.textContent = message;
  box.appendChild(el);
  setTimeout(() => { el.style.opacity = "0"; setTimeout(() => el.remove(), 300); }, 6000);
}
